import { FormTypes } from './form.types';

import { objectIsInArray, filterArrayByProperty } from '../../_global/js/form.utils';

const INITIAL_STATE = {
  invalidFormFields: [],
  dependentIgnoreList: [],
  preventFormSubmissionList: []
};

const formReducer = (state = INITIAL_STATE, action) => {
  let updatedFormFields = null;
  let updatedIgnoreList = null;
  let removeIndex = null;
  let updatedPreventFormSubmissionList = null;

  switch (action.type) {
    case FormTypes.ADD_VALIDATION_FIELD:
      // Add the existing field data to the Array
      updatedFormFields = [...state.invalidFormFields];

      /**
       * Only add the field if it hasn't already failed validation
       * i.e. If it's NOT already being tracked in the state
       */
      if ( !objectIsInArray(updatedFormFields, action.payload.id) ) {
        updatedFormFields.push(action.payload);
      }

      return {
        ...state,
        invalidFormFields: updatedFormFields
      };

    case FormTypes.REMOVE_VALIDATION_FIELD:
      // Remove the provided field data from the existing Array
      updatedFormFields = [...state.invalidFormFields];

      return {
        ...state,
        invalidFormFields: filterArrayByProperty(updatedFormFields, 'id', action.payload, 0, true)
      };

    case FormTypes.ADD_DEPENDENT_FIELDS:
      // Get any existing dependant field data
      updatedIgnoreList = [...state.dependentIgnoreList];

      /**
       * Only add a field if it's NOT already being
       * tracked in the state
       */
      for (let i = 0, j = action.payload.length; i < j; ++i) {
        if (updatedIgnoreList.indexOf(action.payload[i]) === -1) {
          updatedIgnoreList.push(action.payload[i]);
        }
      }

      return {
        ...state,
        dependentIgnoreList: updatedIgnoreList
      };

    case FormTypes.REMOVE_DEPENDENT_FIELDS:
      // Get any existing dependant field data
      updatedIgnoreList = [...state.dependentIgnoreList];

      /**
       * Only remove a field if it's already being
       * tracked in the state
       */
      for (let i = 0, j = action.payload.length; i < j; ++i) {
        // Get the index of the element to remove
        removeIndex = updatedIgnoreList.indexOf(action.payload[i]);

        if (removeIndex !== -1) {
          // Remove this item from the ignore list
          updatedIgnoreList.splice(removeIndex, 1);
        }
      }

      return {
        ...state,
        dependentIgnoreList: updatedIgnoreList
      };

    case FormTypes.ADD_PREVENT_FORM_SUBMISSION_FIELD:
      // Add the existing field IDs to the Array
      updatedPreventFormSubmissionList = [...state.preventFormSubmissionList];

      /**
       * Only add the field ID if it's NOT already being tracked in the state
       */
      if (updatedPreventFormSubmissionList.indexOf(action.payload) === -1) {
        updatedPreventFormSubmissionList.push(action.payload);
      }

      return {
        ...state,
        preventFormSubmissionList: updatedPreventFormSubmissionList
      };

    case FormTypes.REMOVE_PREVENT_FORM_SUBMISSION_FIELD:
        // Add the existing field IDs to the Array
        updatedPreventFormSubmissionList = [...state.preventFormSubmissionList];

        /**
         * Remove the field ID if it's currently being tracked in the state
         */
        if (updatedPreventFormSubmissionList.indexOf(action.payload) !== -1) {
          updatedPreventFormSubmissionList.splice(
            updatedPreventFormSubmissionList.indexOf(action.payload),
            1
          );
        }

        return {
          ...state,
          preventFormSubmissionList: updatedPreventFormSubmissionList
        };

    default:
     return state;
  }
};

export default formReducer;